module.exports = __webpack_public_path__ + "img/lg_ring_r_o_1_null.bf6b9ec6.png";